const grey = {
  100: '#e8e9eb',
  200: '#d2d3d8',
  300: '#bcbdc5',
  400: '#a6a9b2',
  500: '#9194a0',
  600: '#727583',
  700: '#545767',
  800: '#373a4d',
  900: '#1d2033',
};
const slate = {
  100: '#f2f4f7',
  200: '#e4e7f0',
  300: '#d2d9e5',
  400: '#acbdd5',
  500: '#7b91b1',
  600: '#576f92',
  700: '#385075',
  800: '#162040',
  900: '#050c26',
};
const red = {
  100: '#ffd8cc',
  200: '#feb19b',
  300: '#f68a6c',
  400: '#e9603e',
  500: '#d82c0d',
  600: '#aa280f',
  700: '#7e230f',
  800: '#541c0d',
  900: '#2e1308',
};
const yellow = {
  100: '#fff4e0',
  200: '#ffe9c1',
  300: '#ffdfa2',
  400: '#ffd483',
  500: '#feca63',
  600: '#c69e50',
  700: '#91743d',
  800: '#5f4c2b',
  900: '#312819',
};
const green = {
  100: '#e8f6f1',
  200: '#d0eee2',
  300: '#a0dcc6',
  400: '#6bcaab',
  500: '#17b790',
  600: '#1f866a',
  700: '#1d5846',
  800: '#162e26',
  900: '#0f1a16',
};
const blue = {
  100: '#f2f8ff',
  200: '#dde9f8',
  300: '#85beff',
  400: '#268bff',
  50: '#f8fafe',
  500: '#1472ff',
  600: '#145ad0',
  700: '#0f43a3',
  800: '#072e78',
  900: '#001a50',
};
const purple = {
  100: '#f8f1ff',
  200: '#e5cdff',
  300: '#c89cff',
  400: '#a66afe',
  500: '#7b33fb',
  600: '#5926b1',
  700: '#2d0968',
  800: '#25153b',
  900: '#180e21',
};
const teal = {
  100: '#EBF5F7',
  200: '#CEE6EB',
  300: '#9ABACA',
  400: '#2F7492',
  500: '#01567A',
  600: '#014968',
  700: '#193D50',
  800: '#0D212D',
  900: '#05141C',
};
const primary = {
  100: purple[100],
  200: purple[200],
  300: purple[300],
  400: purple[400],
  500: purple[500],
  600: purple[600],
  700: purple[700],
  800: purple[800],
  900: purple[900],
};
const black = '#000000';
const white = '#ffffff';

const brand = {
  black,
  brightBlue: '#66E0F6',
  darkGrey: '#2f2f2f',
  deepBlue: '#3866F5',
  deepPink: '#ec4a77',
  deepPurple: purple[700],
  grey: '#c4c4c4',
  greyBackground: '#f6f6f6',
  greyText: '#8e8e8e',
  magenta: '#bd00ff',
  orange: '#ff9634',
  paleBlue: '#edf7fc',
  pastelGreen: '#d4dca0',
  pastelPink: '#ff9ab6',
  pink: '#ff70c6',
  purple: purple[500],
  teal: '#6bdab6',
  white,
  yellow: '#f6c043',
};

const ui = {
  backgrounds: {
    blue: blue[100],
    default: white,
    green: green[100],
    purple: purple[100],
    red: red[100],
    slate: slate[100],
    teal: teal[100],
    yellow: yellow[100],
  },
  link: {
    active: primary[700],
    default: primary[500],
    disabled: primary[200],
    hover: primary[600],
  },
  semantic: {
    destructive: {
      default: red[500],
      hovered: red[600],
    },
    success: {
      default: green[500],
      hovered: green[600],
    },
    warning: {
      default: yellow[500],
      hovered: yellow[600],
    },
  },
  text: {
    disabled: grey[400],
    placeholder: grey[600],
    primary: black,
    quaternary: grey[400],
    secondary: grey[700],
    tertiary: grey[600],
  },
};

export {
  black,
  blue,
  brand,
  green,
  grey,
  primary,
  purple,
  red,
  slate,
  teal,
  ui,
  white,
  yellow,
};
